import styled from 'styled-components';
import Card from '../../Card';
import { courseScoreColor } from '../../../common/services'


export const StyledCard = styled(Card)`
  &.table-th-centered {
    .table {
      thead {
        th {
          text-align: center;
        }
      }
    }
  }

  .table {
    thead {
      th {
        vertical-align: middle;
        border-bottom-width: 1px;
        text-transform: capitalize;
        color: #3ee9f7;
        font-style: normal;
        font-weight: 500;
        border-top: none;

        i {
          display: none;
        }
      }
    }

    tbody {
      tr {
        .yellow {
          color: #b5f92d;
        }

        .red {
          color: #ff0033;
        }
      }
    }
  }
  @media all and (min-width: 993px) and (max-width: 1200px) {
    width: 100%;
   }
`;

export const ScoreEntry = styled.div`
  :first-child {margin-top: 20px;}
  h2, h3 {font-size: 22px; color: ${props => props.color ? props.color : "#acff24"};}
   h3 {font-size: 19px;}
  p {font-size: 16px; color: #fff;}
`

export const ColorP = styled.p`
  color: #fff;
  font-size: 16px;

  span {color: ${props => props.color}}
`



// WEBPACK FOOTER //
// ./src/components/DataCentre/StudentsPerformance/StudentsPerformance.styles.ts